export default {"src":"https://marketplace-web-assets.vinted.com/_next/static/media/facebook.6a37ec1f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};